import {
  queryOptions,
  useQueryClient,
  useQuery,
  useMutation,
} from "@tanstack/react-query";
import { produce } from "immer";

import { store } from "../store";
import { importAllPersonas } from "@app/utils";
import { getElements } from "@app/services/ccLibraries";
import { storyKey } from "./stories";

export const getPersonasKey = (...keys) => ["personas", ...keys];

export const personaKey = {
  all: ["personas"],
  lists: () => [...personaKey.all, "list"],
  list: (filters) => [...personaKey.lists(), { filters }],
  details: () => [...personaKey.all, "detail"],
  detail: (id) => [...personaKey.details(), id],
};

export const personasQueryOptions = (options = {}) =>
  queryOptions({
    queryKey: personaKey.lists(),
    queryFn: importAllPersonas,
    staleTime: Infinity,
    meta: {
      errorMessage: "Failed to load personas. Please try again.",
    },
    ...options,
  });

export const personaImagesQueryOptions = (libraryId, options = {}) =>
  queryOptions({
    queryKey: personaKey.detail(libraryId),
    queryFn: ({ signal }) => getElements({ libraryId }, { signal }),
    staleTime: Infinity,
    enabled: !!libraryId,
    ...options,
  });

export const usePersonas = (options = {}) => {
  return useQuery(personasQueryOptions(options));
};

export const usePersonaImages = (libraryId, options = {}) => {
  return useQuery(personaImagesQueryOptions(libraryId, options));
};
